<template>
  <el-dialog title="修改" :visible.sync="visible" width="800px" top="3vh" @close="onClose">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="11em"
      class="detail_form"
    >
      <el-form-item label="基地" prop="delivery_com_name">{{
        form.delivery_com_name
      }}</el-form-item>
      <el-form-item label="物料号" prop="material_code">
        {{ form.material_code || "--" }}
      </el-form-item>
      <el-form-item label="物料描述" prop="material_desc">
        <el-input
          placeholder="请输入物料描述"
          v-model="form.material_desc"
        ></el-input>
      </el-form-item>
      <el-form-item label="运输方式" prop="shipping_type">
        <el-input
          placeholder="请输入运输方式"
          v-model="form.shipping_type"
        ></el-input>
      </el-form-item>
      <el-form-item label="分区" prop="subarea">
        <el-input placeholder="请输入分区" v-model="form.subarea"></el-input>
      </el-form-item>
      <el-form-item label="地区" prop="region">
        <el-input placeholder="请输入地区" v-model="form.region"></el-input>
      </el-form-item>
      <el-form-item label="含税价格(元/绝干吨)" prop="total_price">
        <el-input
          placeholder="请输入含税价格"
          v-model="form.total_price"
        ></el-input>
      </el-form-item>
      <el-form-item label="执行日期" prop="execute_time">
        {{ form.execute_time | timeFormat }}
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          placeholder="请输入备注"
          type="textarea"
          v-model="form.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        material_desc: [
          { required: true, message: "请输入物料描述", trigger: "blur" }
        ],
        shipping_type: [
          { required: true, message: "请输入运输方式", trigger: "blur" }
        ],
        subarea: [{ required: true, message: "请输入分区", trigger: "blur" }],
        region: [{ required: true, message: "请输入地区", trigger: "blur" }],
        total_price: [
          { required: true, message: "请输入含税价格", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  filters: {
    timeFormat(time, style = "YYYY-MM-DD") {
      return time ? moment.unix(time).format(style) : "--";
    }
  },
  methods: {
    onOpen(row) {
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    onConfirm() {
      this.$refs.form.validate(v => {
        if (v) {
          this.onUpdate();
        }
      });
    },
    onClose() {
      this.form = {};
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    async onUpdate() {
      try {
        await this.$common.http({
          url: "/api/queue/admin/update_price",
          data: this.form
        });
        this.$emit("ok");
        this.visible = false;
      } catch (error) {}
    }
  }
};
</script>

<style lang="scss" scoped></style>
